import { fileUrl } from "../../../../../utils";

type IpropsIsvOemHeader = {
  profil: string;
  companyName: string;
  roleDiscussion: string;
};
export default function isvToOemHeaderMessage(props: IpropsIsvOemHeader) {
  return (
    <>
      <div className="d-flex mr-5">
        <div className="photo-title">
          {props.profil && <img src={fileUrl(props.profil)} alt="profil" />}
        </div>
        <div className="info-title">
          <div className="company-title">
            <a href="javascript:;" className="disable-click-name">
              {props?.companyName || "-"}
            </a>
          </div>
          <div className="company-type">{props?.roleDiscussion || "-"}</div>
        </div>
      </div>
    </>
  );
}
